// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close[data-v-93de2b22]{font-family:Arial,Helvetica,sans-serif;font-size:14px;position:absolute;height:15px;width:15px;right:-7px;top:-7px;text-align:center;border-radius:50%;font-weight:400;color:#fff;line-height:25px}", ""]);
// Exports
module.exports = exports;
